import React, { useEffect, useRef, useState } from "react";
import OrderTypeSelection from "../../components/order/OrderTypeSelection";
import OrderFilterTypeSelection from "../../components/order/OrderFilterTypeSelection";
import OrderStatusFilterSelection from "../../components/order/OrderStatusFilterSelection";
import OrderSortHeader from "../../components/order/OrderSortHeader";
import OrderList from "../../components/order/OrderList";
import OrderPagination from "../../components/order/OrderPagination";
import { useDispatch, useSelector } from "react-redux";
import {
  setFlightOrders,
  setHotelOrders,
  setHotelOrderTotal,
  setInsuranceOrders,
  setInsuranceOrderTotal,
  setPackageOrders,
  setPackageOrderTotal,
  setEsimOrders,
  setEsimOrderTotal,
  setRefundOrders,
  setReissueOrders,
  setRenameOrders,
  setTourOrders,
  setTourOrderTotal,
  setVoidOrders,
} from "../../redux/reducers/orderSlice";
import OrderListShimmer from "../../components/order/OrderListShimmer";
import getBookings from "../../controllers/booking/getBookings";
import getVoidTicketRequests from "../../controllers/booking/postTicketing/void/getVoidTicketRequests";
import getRefundTicketRequests from "../../controllers/booking/postTicketing/refund/getRefundTicketRequests";
import getTicketRequests from "../../controllers/booking/getTicketRequests";
import getChangeRequests from "../../controllers/booking/postTicketing/change/getChangeRequests";
import IOSSwitch from "../../components/form/IOSSwitch";
import getSuppliersName from "../../controllers/settings/supplier/getFlightSetting";
import updateFlightSetting from "../../controllers/settings/supplier/updateFlightSetting";
import { enqueueSnackbar } from "notistack";
import { useHotels } from "../../hooks/useHotels";
import { useTours } from "../../hooks/useTours";
import {
  templateHotelOrderData,
  templateInsuranceOrderData,
  templatePackageOrderData,
  templateTourOrderData,
} from "../../data/order/ordersData";
import { useInsuranceApi } from "../../hooks/useInsuranceApi";
import { configurations } from "../../configurations";
import axios from "axios";
import useAccount from "../../hooks/useAccount";
import Unauthorized from "../../components/DIsplay/Unauthorized";
import FetchUsersInput from "../../components/form/FetchUsersInput";
import getAccounts from "../../controllers/user/getAccounts";
import getBookingById from "../../controllers/booking/getBookingById";
import getBookingsByAgentId from "../../controllers/booking/getBookingsByAgentId";
import ImportPNR from "../../components/form/ImportPNR";
import refundExample from "./example.json";
import getPackageBookings from "../../controllers/tourPackage/getPackageBookings";
import getEsimBookings from "../../controllers/esim/getEsimBookings";

let cancelToken = null; // Initialize cancelToken outside the component
let cancelTokenSource = null;

function getStatusFilter(
  filterType,
  statusType,
  flightStatusFilterValues,
  ticketStatusFilterValues,
) {
  let field;
  let values;

  if (filterType === "Bookings" && flightStatusFilterValues?.length) {
    if (!statusType || statusType === "All") return {};
    field = "flightBooking.status";
    values = flightStatusFilterValues;
  } else if (filterType === "Freeze" && flightStatusFilterValues?.length) {
    field = "flightBooking.priceFreezeStatus";
    values = flightStatusFilterValues;
  } else if (
    [
      "Tickets",
      "Void Orders",
      "Refund Orders",
      "Date Change",
      "Details Change",
    ].includes(filterType) &&
    ticketStatusFilterValues?.length
  ) {
    if (!statusType || statusType === "All") return {};
    field = "status";
    values = ticketStatusFilterValues;
  }

  if (!field || !values?.length) return {};

  return {
    filterBy: values.map(() => field).join(","),
    filterValue: values.join(","),
  };
}

function NewOrders() {
  const {
    ticketFilterType,
    ticketType,
    ticketStatusType,
    flightStatusFilterValues,
    ticketStatusFilterValues,
    ticketsPage: page,
    ticketsPerPage: perPage,
    ticketSearchValue,
  } = useSelector((state) => state.order);
  // const { getOrders } = useOrders();
  const { getHotelBookings } = useHotels();
  const { getTourBookings } = useTours();
  const { getInsuranceBookings } = useInsuranceApi();
  const [settings, setSettings] = useState();
  const [loadings, setLoadings] = useState({ Flights: true, Bookings: true });
  const [hotelLoading, setHotelLoading] = useState(false);
  const [tourLoading, setTourLoading] = useState(false);
  const [insuranceLoading, setInsuranceLoading] = useState(false);
  const [packageLoading, setPackageLoading] = useState(false);
  const [esimLoading, setEsimLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const loadRequestIdRef = useRef(0);
  const hasPrefetchedRef = useRef(false);

  const [agentQ, setAgentQ] = useState("");
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState();

  // console.log(selectedAgent);

  const { checkPermission } = useAccount();

  const offset = ((page || 1) - 1) * perPage;

  const searchQuery = {};
  if (ticketSearchValue) {
    searchQuery.searchBy =
      "bookingId,account.firstName,account.lastName,flightBooking.pnr";
    searchQuery.keyword = ticketSearchValue;
  }

  useEffect(() => {
    loadSettings();
    loadAgents();
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, [
    ticketFilterType,
    ticketType,
    ticketStatusType,
    flightStatusFilterValues,
    ticketStatusFilterValues,
    page,
    perPage,
    ticketSearchValue,
    selectedAgent,
  ]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page, perPage]);

  const dispatch = useDispatch();
  const statusFilter = getStatusFilter(
    ticketFilterType,
    ticketStatusType,
    flightStatusFilterValues,
    ticketStatusFilterValues,
  );

  async function loadAgents() {
    const params = {
      populate: "detail",
      limit: 50,
      searchBy:
        "firstName,lastName,email,phone,detail.agencyName,detail.companyName,detail.tradingName",
      keyword: agentQ,
    };

    if (cancelTokenSource)
      cancelTokenSource.cancel("Operation canceled due to new request.");
    cancelTokenSource = axios.CancelToken.source();

    setLoadings({ ...loadings, loadAgent: true });
    const res = await getAccounts(
      new URLSearchParams(params)?.toString(),
      cancelTokenSource.token,
    );
    setLoadings({ ...loadings, loadAgent: false });
    if (res.return) {
      setAgents(res?.data?.data);
    }
  }

  const loadData = async () => {
    const requestId = ++loadRequestIdRef.current;

    if (cancelToken)
      cancelToken.cancel("Operation canceled due to new request.");
    cancelToken = axios.CancelToken.source();

    setLoadings((prev) => ({
      ...prev,
      [ticketType]: true,
      ...(ticketType === "Flights" ? { [ticketFilterType]: true } : {}),
    }));
    if (ticketType === "Flights") setLoading(true);

    const loadActiveType = () => {
      if (ticketType === "Flights") return loadCase();
      if (ticketType === configurations.stayKeyword) return loadHotel();
      if (ticketType === configurations.tourKeyword) return loadTour();
      if (ticketType === configurations.insuranceKeyword)
        return loadInsurance();
      if (ticketType === configurations.services.package.value)
        return loadPackages();
      if (ticketType === configurations.services.esim.value) return loadEsims();
      return Promise.resolve([]);
    };

    try {
      await loadActiveType();
      if (requestId !== loadRequestIdRef.current) return;
    } finally {
      if (requestId === loadRequestIdRef.current) {
        setLoading(false);
        setLoadings((prev) => ({
          ...prev,
          [ticketType]: false,
          [ticketFilterType]: false,
        }));
      }
    }

    if (hasPrefetchedRef.current) return;
    hasPrefetchedRef.current = true;

    const background = [];
    if (ticketType !== "Flights") background.push(loadCase());
    if (ticketType !== configurations.stayKeyword)
      background.push(loadHotel());
    if (ticketType !== configurations.tourKeyword)
      background.push(loadTour());
    if (ticketType !== configurations.insuranceKeyword)
      background.push(loadInsurance());
    if (ticketType !== configurations.services.package.value)
      background.push(loadPackages());
    if (ticketType !== configurations.services.esim.value)
      background.push(loadEsims());
    Promise.allSettled(background);
  };

  async function loadCase() {
    switch (ticketFilterType) {
      case "Void Orders":
        return loadVoidOrders();
      case "Refund Orders":
        return loadRefundOrders();
      case "Date Change":
        return loadChangeRequests();
      case "Details Change":
        return loadChangeName();
      case "Tickets":
        return loadTicketRequests();
      default:
        return load();
    }
  }

  async function loadChangeRequests() {
    const res = await getChangeRequests(
      {
        limit: perPage,
        offset,
        filterBy: "changeRequest",
        filterValue: "Flight",
        ...(statusFilter.filterBy
          ? {
              filterBy: `changeRequest,${statusFilter.filterBy}`,
              filterValue: `Flight,${statusFilter.filterValue}`,
            }
          : {}),
        ...searchQuery,
      },
      cancelToken.token,
    );
    let data = [];
    if (res.return) {
      res.data?.data?.map((obj) => {
        // obj?.flightBooking?.map((flightObj) =>
        data.push({
          ...obj,
          flightBooking: [obj?.flightBooking],
          flightObj: obj?.flightBooking,
          type: "Flight",
        });
        // );
        return true;
      });
      dispatch(
        setReissueOrders([
          ...data,
          ...Array((res?.data?.meta?.total || 0) - (data?.length || 0)),
        ]),
      );
      // data = data?.map((obj) => templateFlightOrderData(obj));
    }
    return data;
  }

  async function loadChangeName() {
    const res = await getChangeRequests(
      {
        limit: perPage,
        offset,
        filterBy: "changeRequest",
        filterValue: "PassengerInfo",
        ...(statusFilter.filterBy
          ? {
              filterBy: `changeRequest,${statusFilter.filterBy}`,
              filterValue: `PassengerInfo,${statusFilter.filterValue}`,
            }
          : {}),
        ...searchQuery,
      },
      cancelToken.token,
    );
    let data = [];
    if (res.return) {
      res.data?.data?.map((obj) => {
        // obj?.flightBooking?.map((flightObj) =>
        data.push({
          ...obj,
          flightBooking: [obj?.flightBooking],
          flightObj: obj?.flightBooking,
          type: "Flight",
        });
        // );
        return true;
      });
      dispatch(
        setRenameOrders([
          ...data,
          ...Array((res?.data?.meta?.total || 0) - (data?.length || 0)),
        ]),
      );
      // data = data?.map((obj) => templateFlightOrderData(obj));
    }
    return data;
  }

  async function loadTicketRequests() {
    const res = await getTicketRequests(
      {
        limit: perPage,
        offset,
        // filterBy: "flightBooking.status",
        // filterValue: "Issued",
        ...statusFilter,
        ...searchQuery,
      },
      cancelToken.token,
    );
    let data = [];
    if (res.return) {
      res.data?.data?.map((obj) => {
        // obj?.flightBooking?.map((flightObj) =>
        data.push({
          ...obj,
          flightBooking: [obj?.flightBooking],
          flightObj: obj?.flightBooking,
          type: "Flight",
        });
        // );
        return true;
      });
      dispatch(
        setFlightOrders([
          ...data,
          ...Array((res?.data?.meta?.total || 0) - (data?.length || 0)),
        ]),
      );
      // data = data?.map((obj) => templateFlightOrderData(obj));
    }
    return data;
  }

  async function loadRefundOrders() {
    const res = await getRefundTicketRequests(
      {
        limit: perPage,
        offset,
        ...statusFilter,
        ...searchQuery,
      },
      cancelToken.token,
    );
    let data = [];
    if (res.return) {
      let items = res.data?.data;
      if (refundExample) {
        items = [refundExample, ...items];
      }

      items?.map((obj) => {
        // obj?.flightBooking?.map((flightObj) =>
        data.push({
          ...obj,
          flightBooking: [obj?.flightBooking],
          flightObj: obj?.flightBooking,
          type: "Flight",
        });
        // );
        return true;
      });
      dispatch(
        setRefundOrders([
          ...data,
          ...Array((res?.data?.meta?.total || 0) - (data?.length || 0)),
        ]),
      );
      // data = data?.map((obj) => templateFlightOrderData(obj));
    }
    return data;
  }

  async function loadVoidOrders() {
    const res = await getVoidTicketRequests(
      {
        limit: perPage,
        offset,
        ...statusFilter,
        ...searchQuery,
      },
      cancelToken.token,
    );
    let data = [];
    if (res.return) {
      res.data?.data?.map((obj) => {
        // obj?.flightBooking?.map((flightObj) =>
        data.push({
          ...obj,
          flightBooking: [obj?.flightBooking],
          flightObj: obj?.flightBooking,
          type: "Flight",
        });
        // );
        return true;
      });
      dispatch(
        setVoidOrders([
          ...data,
          ...Array((res?.data?.meta?.total || 0) - (data?.length || 0)),
        ]),
      );
      // data = data?.map((obj) => templateFlightOrderData(obj));
    }
    return data;
  }

  async function load() {
    if (
      ticketType === configurations.stayKeyword ||
      ticketType === configurations.tourKeyword ||
      ticketType === configurations.insuranceKeyword
    )
      return [];

    const agentFilter = {};
    if (selectedAgent?._id) agentFilter["account"] = selectedAgent?._id;

    let res = { return: 0, msg: "ERRBKRT" };

    if (selectedAgent?._id)
      res = await getBookingsByAgentId(
        selectedAgent?._id,
        { limit: perPage, offset, ...statusFilter },
        cancelToken.token,
      );
    else
      res = await getBookings(
        { limit: perPage, offset, ...statusFilter, ...searchQuery },
        cancelToken.token,
      );
    let data = [];
    if (res.return) {
      res.data?.data?.map((obj) => {
        obj?.flightBooking?.map((flightObj) =>
          data.push({ ...obj, flightObj, type: "Flight" }),
        );
        return true;
      });
      dispatch(
        setFlightOrders([
          ...data,
          ...Array((res?.data?.meta?.total || 0) - (data?.length || 0)),
        ]),
      );
      // data = data?.map((obj) => templateFlightOrderData(obj));
    }
    return data;
  }

  const loadSettings = async () => {
    try {
      // setLoading(true); // Set loading to true before fetching
      const res = await getSuppliersName();
      setSettings({ ...res.data });
    } catch (error) {
      console.error("Error fetching suppliers", error);
    } finally {
      // setLoading(false); // Set loading to false after fetching completes
    }
  };

  async function handleAutoTicket(autoTicket) {
    const res = await updateFlightSetting({ autoTicket });
    if (res?.return) {
      loadSettings();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  const loadTour = async () => {
    // if (ticketType !== "Tour") return [];

    let [items, total] = await getTourBookings(
      {
        limit: perPage,
        offset,
        status: ticketFilterType,
        ...searchQuery,
      },
      setTourLoading,
    );
    items = items?.map((obj) => templateTourOrderData(obj));
    dispatch(setTourOrders(items));
    dispatch(setTourOrderTotal(total));
    return items;
  };

  const loadHotel = async () => {
    let [items, total] = await getHotelBookings(
      {
        limit: perPage,
        offset,
        status: ticketFilterType,
        ...searchQuery,
      },
      setHotelLoading,
    );
    items = items?.map((obj) => templateHotelOrderData(obj));
    dispatch(setHotelOrders(items));
    dispatch(setHotelOrderTotal(total));
    return items;
  };

  const loadInsurance = async () => {
    // if (ticketType !== configurations.insuranceKeyword) return [];

    let [items, total] = await getInsuranceBookings(
      {
        limit: perPage,
        // limit: 1,
        offset,
        status: ticketFilterType,
        ...searchQuery,
      },
      setInsuranceLoading,
    );
    items = items?.map((obj) => templateInsuranceOrderData(obj));
    dispatch(setInsuranceOrders(items));
    dispatch(setInsuranceOrderTotal(total));
    return items;
  };

  const loadPackages = async () => {
    // if (ticketType !== configurations.insuranceKeyword) return [];

    let response = await getPackageBookings(
      {
        limit: perPage,
        offset,
        // status: ticketFilterType,
        // ...searchQuery,
      },
      setPackageLoading,
    );

    let items = response?.data?.data || [];
    const total = response?.data?.meta?.total || 0;
    items = items?.map((obj) => templatePackageOrderData(obj));
    dispatch(setPackageOrders(items));
    dispatch(setPackageOrderTotal(total));
    return items;
  };

  const loadEsims = async () => {
    let response = await getEsimBookings(
      {
        limit: perPage,
        offset,
        populate: "account",
      },
      setEsimLoading,
    );

    let items = response?.data?.data || [];
    const total = response?.data?.meta?.total || 0;
    dispatch(setEsimOrders(items));
    dispatch(setEsimOrderTotal(total));
    return items;
  };

  function loadingCheck() {
    if (ticketType === "Flights") {
      return Boolean(
        loading || loadings[ticketFilterType] || loadings.Flights,
      );
    }
    if (ticketType === configurations.stayKeyword) return hotelLoading;
    if (ticketType === configurations.tourKeyword) return tourLoading;
    if (ticketType === configurations.insuranceKeyword) return insuranceLoading;
    if (ticketType === configurations.services.package.value)
      return packageLoading;
    if (ticketType === configurations.services.esim.value) return esimLoading;
    return Boolean(loadings[ticketType]);
  }

  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <div className="flex gap-4 justify-between items-center w-full overflow-scroll scroll-hide">
          <OrderTypeSelection reload={loadData} />
          <div className="self-end flex flex-col gap-4 gap-y-7">
            <label className="flex  items-center justify-end sm:whitespace-nowrap mx-4">
              Auto Ticketing
              <IOSSwitch
                checked={settings?.autoTicket}
                onChange={(ev) => handleAutoTicket(ev.target.checked)}
              />
            </label>
            {ticketFilterType === "Bookings" ? (
              <div className="flex-1 flex items-end gap-2">
                <ImportPNR />
                <FetchUsersInput
                  from={agents}
                  loading={loadings?.agent}
                  onChange={(agent) => setSelectedAgent(agent)}
                  label="Agents"
                  disableClearable={false}
                />
              </div>
            ) : null}
          </div>
        </div>
        {!checkPermission("read:flight-booking") && ticketType === "Flights" ? (
          <Unauthorized className={"min-h-[70vh]"} />
        ) : (
          <div className={Classname.content}>
            <OrderFilterTypeSelection />
            <OrderStatusFilterSelection />
            <OrderSortHeader />
            {loadingCheck() ? (
              <OrderListShimmer rows={Math.min(perPage || 6, 8)} />
            ) : (
              <div className="z-10">
                <OrderList
                  reload={loadData}
                  // ogData={ogData} orders={ordersList}
                  perPage={perPage}
                />
              </div>
            )}
            <div>
              <OrderPagination
                perPage={perPage}
                // total={}
                // count={parseInt(Math.max(ordersList?.length,perPage)/perPage)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NewOrders;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center px-3 sm:px-10 font-main",
  content: "flex w-full max-w-7xl flex-col flex-1 pb-96",
};
